import { FC } from 'react';

import { ChevronDownIcon } from '../../../../assets/icons/index';

/**
 * The small chevron after a blue text link — a two-thirds glyph centred in a 16px box. It nudges
 * forward while its link (marked `group`) is hovered.
 */
export const LinkArrow: FC = () => (
  <span className="flex size-4 shrink-0 items-center justify-center transition-transform duration-200 ease-out group-hover:translate-x-0.5">
    <ChevronDownIcon className="size-[10.667px] -rotate-90" iconColor="#2565C8" />
  </span>
);
